<template>
  <div>
    <svg :width="iconSize" :height="iconSize" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
          d="M21 3H5C3.89913 3.0053 3.00957 3.89913 3.00957 5L3 23L7 19H21C22.1032 18.9967 22.9967 18.1032 23 17V5C22.9967 3.89678 22.1032 3.0033 21 3ZM7 10H19V12H7V10ZM15 15H7V13H15V15ZM19 9H7V7H19V9Z"
          :fill="color"/>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'IconSvgSnmmiMessages',
  props: {
    color: {
      type: String,
      default: '#000000',
    },
    size: {
      type: Number,
      default: null,
    },
  },
  computed: {
    iconSize() {
      return this.size ? `${this.size}px` : '44px'
    },
  },
}
</script>

<style scoped></style>